import React from 'react'
import { Icon } from '@chakra-ui/icons'
import { FaCopy } from 'react-icons/fa6'
import { Button } from '@chakra-ui/react'
import { useDisclosure } from '@chakra-ui/react'

import CopyTemplateModal from './modal'
import {
    AppointmentFieldsFragment,
    ChatFieldsFragment,
} from '~graphql/generated/graphql'
import MessageTemplatesProvider from '~components/engagement/message-templates/provider'
import IconButtonWithTooltip from '~components/shared/icon-button-with-tooltip'
import { PatientIdAndName } from './types'

interface Props {
    chat: ChatFieldsFragment
    appointment?: AppointmentFieldsFragment
    setText: (text: string) => void
    patientFilter?: string[]
    onCopyTemplatePatient?: (patient: PatientIdAndName | undefined) => void
    /** Force icon-only display regardless of breakpoint. */
    compact?: boolean
}

export default function CopyTemplateButton({
    chat,
    appointment,
    setText,
    patientFilter,
    onCopyTemplatePatient,
    compact = false,
}: Props) {
    const { isOpen, onOpen, onClose } = useDisclosure()

    if (!chat.clinic) return null

    const selectedPatient =
        patientFilter?.length === 1
            ? chat.client.patients?.find(p => p.id === patientFilter[0])
            : undefined

    return (
        <MessageTemplatesProvider
            clinic={chat.clinic}
            isOpen={isOpen}
            pageSize={5}
        >
            <Button
                leftIcon={<Icon as={FaCopy} fontSize="xs" />}
                size="xs"
                borderWidth={1}
                borderColor="gray.200"
                h="28px"
                rounded="full"
                variant="subtle"
                onClick={onOpen}
                display={
                    compact
                        ? 'none'
                        : {
                              base: 'none',
                              lg: 'flex',
                          }
                }
            >
                Copy from template
            </Button>
            <IconButtonWithTooltip
                icon={<Icon as={FaCopy} fontSize="xs" />}
                label="Copy from template"
                size="xs"
                w="28px"
                h="28px"
                rounded="full"
                variant="subtle"
                borderWidth={1}
                borderColor="gray.200"
                tooltipOverrides={{
                    placement: 'top',
                }}
                display={
                    compact
                        ? 'flex'
                        : {
                              base: 'flex',
                              lg: 'none',
                          }
                }
                onClick={onOpen}
            />
            {isOpen && (
                <CopyTemplateModal
                    isOpen={isOpen}
                    onClose={onClose}
                    clinic={chat.clinic}
                    client={chat.client}
                    patient={selectedPatient}
                    patientFilter={patientFilter}
                    appointment={appointment}
                    setText={setText}
                    onCopyTemplatePatient={onCopyTemplatePatient}
                />
            )}
        </MessageTemplatesProvider>
    )
}
